import deepEqual from 'deep-equal';
import memoizeOne from 'memoize-one';

import { getLeapQuery } from '@atlassian/search-client/leap-query';

import { trackFunctionPromise } from './track-promise';

export const getLeapQueryMemo: import('memoize-one').MemoizedFn<
	(args_0: {
		query: string;
		product: string;
		cloudId?: string;
	}) => import('./track-promise').TrackedPromise<{
		title: number;
		candidates: string[];
	}>
> = memoizeOne(trackFunctionPromise(getLeapQuery), deepEqual);
